import { customerExperiencesNavigationResource } from '@jira/router-resources__customer-experiences-navigation/src/customerExperiencesNavigationResource.tsx';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import { serviceDeskAnalyticsContextResource } from '@jira/router-resources__service-desk-analytics-context/src/useServiceDeskAnalyticsContext.tsx';
import { serviceDeskContextResource } from '@jira/router-resources__service-desk-context/src/serviceDeskContextResource.tsx';
import type { RouteResource } from '@atlassian/react-resource-router';

export function getCsmExperiencesResources(): RouteResource[] {
	return [
		projectContextResource,
		serviceDeskContextResource,
		serviceDeskAnalyticsContextResource,
		customerExperiencesNavigationResource,
	];
}
